// extracted by mini-css-extract-plugin
export default {"block":"filter_block__WGdSO","parametr":"filter_parametr__yZONQ","selected":"filter_selected__Z5bAi"};